export default __webpack_public_path__ + "static/media/36I-102710_-15707_0.b5be4213.jpg";